module.exports = __webpack_public_path__ + "static/src/content/images/osborne bulls.9ef1428.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/osborne bulls.png
// module id = 9W00
// module chunks = 0